import FormInput from "../UI/FormInput";
import { useTranslation } from "react-i18next";

const StaffInput = ({ helpText = null }) => {
  const { t } = useTranslation("form");
  return (
    <FormInput
      label={t("ofStaff")}
      placeholder={t("ofStaff")}
      id="num_staff"
      type="text"
      autoComplete="staff"
      required={false}
      helperText={helpText}
      checkType="number"
      attr={{ maxLength: 5 }}
    />
  );
};
export default StaffInput;